import { ReactNode } from 'react';
import smallTitle from '../../imgs/small_title.png';
import styles from './index.module.scss';

interface SectionTitleProps {
  children: ReactNode;
}

const SectionTitle = ({ children }: SectionTitleProps) => (
  <h2 className={styles.sectionTitle}>
    <img src={smallTitle} alt="" aria-hidden="true" />
    {children}
  </h2>
);

export default SectionTitle;
